// JsFromRoutes CacheKey e20bca31bd2d1ed09f84506f51865d62
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  preview: /* #__PURE__ */ definePathHelper('get', '/preview/landing_page/:id'),
  show: /* #__PURE__ */ definePathHelper('get', '/gifts/:slug'),
  index: /* #__PURE__ */ definePathHelper('get', '/'),
  root: /* #__PURE__ */ definePathHelper('get', '/'),
}
